import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class MentorshipService {
  constructor(private http: HttpClient, private _global: GlobalService) {}

  createMentor(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createMentor}`,
      payload
    );
  }

  getMentor(id) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getOneMentor}/${id}/find`
    );
  }

  getAllMentors() {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllMentors}`
    );
  }

  deleteMentor(id) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteMentor}/${id}/delete`
    );
  }

  assignMentor(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignMentors}`,
      payload
    );
  }
}
